import { render, staticRenderFns } from "./CedTableMonopoly.vue?vue&type=template&id=1a6540ef"
import script from "./CedTableMonopoly.vue?vue&type=script&lang=js"
export * from "./CedTableMonopoly.vue?vue&type=script&lang=js"
import style0 from "./CedTableMonopoly.vue?vue&type=style&index=0&id=1a6540ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports